import { saveToStorage } from '../helpers/storageHelper';
import createDataProvider from './createDataProvider';
import { providerContextReducer } from './reducer';

const initialState = {
  form: {
    data: {},
    initialized: false,
    hasUnsavedChanges: false,
    isSubmitting: false,
    triggerSubmit: false,
    triggerDiscard: false,
    containerWidth: null,
    errors: {}
  },
  regAssociation: { value: null, pkRegAssociation: null },
  view: {
    isClassicView: true,
    isClassicMerchView: false,
    isClassicReportView: false
  }
};

const setFormData = (dispatch) => async ({
  data,
  containerWidth,
  saveButtonText = null,
  hideDiscardButton = false,
  getIsVisible = null,
  hasUnsavedChanges = true,
  triggerDiscard = false,
  loading = false
}) => {
  dispatch({
    type: 'success',
    stateName: 'form',
    payload: {
      data,
      hasUnsavedChanges,
      containerWidth,
      saveButtonText,
      getIsVisible,
      hideDiscardButton,
      triggerDiscard,
      isSubmitting: loading,
      initialized: true,
      triggerSubmit: false
    }
  });
};

const triggerFormDiscard = (dispatch) => async () => {
  dispatch({
    type: 'success',
    stateName: 'form',
    payload: { triggerDiscard: true }
  });
};

const triggerFormSubmit = (dispatch) => async () => {
  dispatch({
    type: 'success',
    stateName: 'form',
    payload: { triggerSubmit: true }
  });
};

const resetForm = (dispatch) => async () => {
  dispatch({
    type: 'success',
    stateName: 'form',
    payload: {
      data: {},
      hasUnsavedChanges: false,
      isSubmitting: false,
      triggerSubmit: false,
      triggerDiscard: false,
      initialized: false,
      errors: {}
    }
  });
};

const changeAssociation = (dispatch) => async (
  { pkRegAssociation, regAssociation },
  skipStorage = false
) => {
  try {
    if (!skipStorage) {
      saveToStorage('pkRegAssociation', pkRegAssociation);
    }
    dispatch({
      type: 'success',
      stateName: 'regAssociation',
      payload: {
        pkRegAssociation: pkRegAssociation?.toString(),
        value: regAssociation
      }
    });
  } catch {
    dispatch({
      type: 'error',
      stateName: 'regAssociation',
      payload: 'Oops something went wrong'
    });
  }
};

const changeClassicViewSettings = (dispatch) => async (
  { isClassicView },
  skipStorage = false
) => {
  try {
    if (!skipStorage) {
      saveToStorage('isClassicView', isClassicView.toString());
    }
    dispatch({
      type: 'success',
      stateName: 'view',
      payload: { isClassicView }
    });
  } catch {
    dispatch({
      type: 'error',
      stateName: 'view',
      payload: 'Oops something went wrong'
    });
  }
};

const changeMerchViewSettings = (dispatch) => async (
  { isClassicView },
  skipStorage = false
) => {
  try {
    if (!skipStorage) {
      saveToStorage('isClassicMerchView', isClassicView.toString());
    }
    dispatch({
      type: 'success',
      stateName: 'view',
      payload: { isClassicMerchView: isClassicView }
    });
  } catch {
    dispatch({
      type: 'error',
      stateName: 'view',
      payload: 'Oops something went wrong'
    });
  }
};

const changeReportViewSettings = (dispatch) => async (
  { isClassicView },
  skipStorage = false
) => {
  try {
    if (!skipStorage) {
      saveToStorage('isClassicReportView', isClassicView.toString());
    }
    dispatch({
      type: 'success',
      stateName: 'view',
      payload: { isClassicReportView: isClassicView }
    });
  } catch {
    dispatch({
      type: 'error',
      stateName: 'view',
      payload: 'Oops something went wrong'
    });
  }
};

export const { Provider, Context } = createDataProvider(
  providerContextReducer,
  {
    changeAssociation,
    changeClassicViewSettings,
    changeMerchViewSettings,
    changeReportViewSettings,
    resetForm,
    setFormData,
    triggerFormDiscard,
    triggerFormSubmit
  },
  initialState
);
